export function SearchIcon({
  width = 16,
  height = 16,
  className = '',
  color = '#AC3FFF',
}: {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.84717 0.275146C6.41081 -0.0916345 8.03841 -0.0916246 9.60205 0.275146C11.8711 0.807392 13.643 2.57935 14.1753 4.84839C14.5421 6.41204 14.5421 8.03962 14.1753 9.60327C13.96 10.521 13.5419 11.3574 12.9702 12.0632L15.811 14.9041C16.0618 15.1548 16.0618 15.5615 15.811 15.8123C15.5603 16.0629 15.1535 16.063 14.9028 15.8123L12.062 12.9714C11.3561 13.543 10.5197 13.9613 9.60205 14.1765C8.03842 14.5433 6.4108 14.5433 4.84717 14.1765C2.57828 13.6443 0.807222 11.8721 0.274902 9.60327C-0.0918848 8.0396 -0.0918848 6.41206 0.274902 4.84839C0.807174 2.57946 2.57824 0.807422 4.84717 0.275146Z"
        fill={color}
      />
    </svg>
  );
}

export default SearchIcon;
